export enum FeatureFlag {
  IS_OTP_TOGGLING_ENABLED = 'portal_rollout_toggling_otp',
  ORDER_TYPE_PER_MERCHANT = 'order_type_per_merchant',
  IS_ACCESS_TYPE_CONTROLLED = 'portal_is_access_type_controlled'
}
